import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "k-basic-popup__wrapper full-width shadow-3 hide-scrollbar" }
const _hoisted_2 = { class: "k-basic-popup__container rounded-48 q-pa-lg" }


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KBasicPopup' },
  __name: 'KBasicPopup',
  props: {
    "modelValue": { type: Boolean, ...{ required: true } },
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {



const modelValue = _useModel<boolean>(__props, "modelValue")

return (_ctx: any,_cache: any) => {
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, _mergeProps({
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    class: "k-basic-popup"
  }, _ctx.$attrs), {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ]),
    _: 3
  }, 16, ["modelValue"]))
}
}

})